<template>
  <!-- 创作活动 -->
  <div>
    <loadingPage v-if="loading" style="height:5rem"></loadingPage>
    <div class="activity_square " v-if="activitiesList.length !== 0 && !loading">
      <div class="slide_discription">
        <div class="slide_discription_l">
          <div class="border_l"></div>
          <p>创作活动</p>
          <Button type="primary" @click="toggleAll" :class="isShowAll ? 'shadow' : ''">全部</Button>
          <Button type="success" style="margin-left: .1rem" @click="toggleUnderway" :class="isShowUnderway ? 'shadow' : ''">进行中</Button>
          <Button class="btn_over" @click="toggleOver" :class="isShowOver ? 'shadow' : ''">已结束</Button>
        </div>
        <slot name="more"></slot>
      </div>
      <div class="acTest" style="" v-for="(item, i) in activitiesList" :key="i" @click="toActivityDetail(i)">
        <!-- 全部 -->
        <div class="acItem" v-if="isShowAll">
          <div class="create_activity">
            <div class="active_info">
              <div class="active_num">
                已参与<b>{{ item.planCount - item.surplusCount }}</b
                >人
              </div>
            </div>
            <img :src="item.cover" class="create_activity_pics" />
          </div>
          <div class="create_activity_info">
            <div class="acName">{{ item.name }}</div>
            <div class="acToos">
              <span class="acTips" v-if="item.activitiesStatusValue == '进行中'">{{ item.activitiesStatusValue }}</span>
              <span class="overClass" v-else>{{ item.activitiesStatusValue }}</span
              ><Icon type="ios-time-outline" size="12" v-if="item.time!==''" /><span class="asTime" >{{ item.time }}</span>
            </div>
          </div>
        </div>
        <!-- 进行中 -->
        <div class="acItem" v-else-if="isShowUnderway && item.status === 2">
          <div class="create_activity">
            <div class="active_info">
              <div class="active_num">
                已参与<b>{{ item.planCount - item.surplusCount }}</b
                >人
              </div>
            </div>
            <img :src="item.cover" class="create_activity_pics" />
          </div>
          <div class="create_activity_info">
            <div class="acName">{{ item.name }}</div>
            <div class="acToos">
              <span class="acTips" v-if="item.activitiesStatusValue == '进行中'">{{ item.activitiesStatusValue }}</span>
                <span class="overClass" v-else>{{ item.activitiesStatusValue }}</span
                ><Icon type="ios-time-outline" size="12" v-if="item.time!==''"/><span class="asTime" >{{ item.time }}</span>
            </div>
          </div>
        </div>
        <!-- 已结束 -->
        <div class="acItem" v-else-if="isShowOver && item.status === 4">
          <div class="create_activity">
            <div class="active_info">
              <div class="active_num">
                已参与<b>{{ item.planCount - item.surplusCount }}</b
                >人
              </div>
            </div>
            <img :src="item.cover" class="create_activity_pics" />
          </div>
          <div class="create_activity_info">
            <div class="acName">{{ item.name }}</div>
            <div class="acToos">
              <span :class="[{ acTips: true }, { overClass: overClass }]">{{ item.activitiesStatusValue }}</span
              ><Icon type="ios-time-outline" size="12" v-if="item.time!==''"/><span class="asTime" v-if="item.time!==''">{{ item.time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nullPage v-else-if="!activityList.length && !loading&&isSinglePage">
      <div slot="tipsText">暂无记录~</div>
    </nullPage>
    <div class="tip" v-else-if="!activityList.length && !loading"></div>
  </div>
</template>
<script>
import nullPage from './nullPage.vue'
import { getActivitiesList } from '@/api/index'
import loadingPage from './loading.vue'
export default {
  components: { loadingPage, nullPage },
  name: 'activitiesList',
  props:{
    isSinglePage:{
      type:Boolean,
      default:false
    },
    acList:{
      type:Array,
      default:null
    }
  },
  data() {
    return {
      activitiesList: [],
      loading: true,
      overClass: false,
      isShowAllBtn: true,
      isShowUnderway: false,
      isShowOver: false,
      isShowAll: true
    }
  },
  computed: {
    activityList() {
      return this.sortByKey(this.activitiesList, 'surplusCount')
    }
  },
  methods: {
    sortByKey(array, key) {
      // (数组、排序的列)
      return array.sort(function(a, b) {
        var x = a[key]
        var y = b[key]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    // 活动广场
    async _getActivitiesList() {
      this.loading = true
      const res = await getActivitiesList()
      this.loading = false
      if (res.success !== true) return this.$Message.error(res.message)
      if(res.result!==null){
        if(res.result){
          this.activitiesList = res.result
          this.activitiesList.forEach(item => {
            const endTime = new Date(item.endTime)
            const startTime = new Date(item.startTime)
            const currentTime = new Date()

            // 活动没开始
            if (startTime.getTime() > currentTime.getTime()) {
              let timeNone = startTime.getTime() - currentTime.getTime()
              let timeDate = parseInt(timeNone / 1000)
              let d = parseInt(timeDate / (24 * 60 * 60))
              let h = this.formate(parseInt((timeDate / (60 * 60)) % 24))
              let m = this.formate(parseInt((timeDate / 60) % 60))
              item.time = `距离开始：${d}天${h}小时${m}分`
              item.activitiesStatusValue = '进行中'
              item.status=1
            } else {
              let timeDiffer = endTime.getTime() - currentTime.getTime()
              if (timeDiffer > 0) {
                let timeDate = parseInt(timeDiffer / 1000)
                let d = parseInt(timeDate / (24 * 60 * 60))
                let h = this.formate(parseInt((timeDate / (60 * 60)) % 24))
                let m = this.formate(parseInt((timeDate / 60) % 60))
                item.time = `倒计时：${d}天${h}小时${m}分`
                item.activitiesStatusValue = '进行中'
                this.overClass = false
                item.status=2
              } else {
                item.time = ''
                item.activitiesStatusValue = '评审中...'
                item.status=3
              }
              // if (item.activitiesStatus === '1') {
              if (item.activitiesStatus == '1') {
                item.time = '活动已结束'
                item.activitiesStatusValue = '已结束'
                this.overClass = true
                item.status=4
              }
            }
          })
        }
      }
      
    },
    // 不足两位前补零
    formate(time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    },
    // 点击按钮切换进行中或已结束的活动
    toggleAll() {
      this.isShowUnderway = false
      this.isShowOver = false
      this.isShowAll = true
    },
    toggleUnderway() {
      this.isShowUnderway = true
      this.isShowOver = false
      this.isShowAll = false
    },
    toggleOver() {
      this.isShowOver = true
      this.isShowUnderway = false
      this.isShowAll = false
    },
    toActivityDetail(i) {
      // 点击的活动id
      let id = this.activitiesList[i].id
      let activitiesStatus = this.activitiesList[i].activitiesStatus
      this.$router.push(`/activityDetail?id=${id}&activitiesStatus=${activitiesStatus}`)
    },
    compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    }
  },
  mounted() {
    this._getActivitiesList()
  }
}
</script>
<style lang="less" scoped>
// @import '../../student/style/opusSquare.less';
// 活动广场
.activity_square {
  position: relative;
  width: 14rem;
  // height: 3.5rem;
  padding-top: 0.2rem;
  margin-bottom: 0.15rem;
  overflow: hidden;
  .slide_discription {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 0.24rem;
    margin-bottom: 0.2rem;
    .slide_discription_l {
      height: 100%;
      display: inline-flex;
      align-items: flex-end;
      .border_l {
        float: left;
        width: 0.06rem;
        height: 100%;
        border-radius: 0.03rem;
        background-color: #76d18e;
      }
      .ivu-btn {
        color: #fff;
        width: 0.63rem;
        height: 0.24rem;
        font-size: 0.14rem;
        text-align: center;
        padding: 0;
        border-radius: 0.12rem;
      }
      .btn_over {
        margin-left: 0.1rem;
        background-color: #999;
        border: none;
      }

      p {
        display: inline-block;
        margin: -0.07rem 0.2rem 0 0.1rem;
        font-family: 'PingFang-SC-Medium';
        color: #333;
        font-size: 0.18rem;
      }
    }

    a {
      font-size: 0.18rem;
      color: #76d18e;
    }
  }
  .create_activity {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 1.94rem;
    text-align: center;
    background-color: #82b1ff;
    margin-bottom: 0.1rem;
    border-top-left-radius: 0.12rem;
    border-top-right-radius: 0.12rem;
    .active_over {
      width: 0.72rem;
      border-bottom-right-radius: 0.12rem;
      height: 100%;
      text-align: center;
    }
    .over_bg {
      background-color: #999;
    }
    .underway {
      background-color: #76d18e;
    }
    .active_num {
      position: absolute;
      top: 0.06rem;
      right: 0.06rem;
      font-size: 0.12rem;
      color: #fff;
      border-radius: 0.05rem;
      background-color: #ff8301;
      height: 0.28rem;
      padding: 0 0.1rem;
      line-height: 0.28rem;
      z-index: 1;
      box-shadow: 0 0 0.2rem rgba(0, 0, 0, 0.3);
      b {
        font-size: 0.16rem;
        font-weight: 400;
        margin: 0 0.03rem;
      }
    }
    .create_activity_pics {
      width: 100%;
      height: 100%;
      cursor: pointer;
      transition: 0.6s;
      &:hover {
        transform: scale(1.1);
      }
    }
    .fire {
      position: absolute;
      top: 0.1rem;
      right: 0.12rem;
    }
  }
  .create_activity_info {
    padding-left: 0.1rem;
    width: 100%;
    height: 0.42rem;
    font-size: 0.14rem;
    .acName {
      font-size: 0.16rem;
      color: #333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .acToos {
      display: flex;
      align-items: center;
      font-size: 0.12rem;
      margin-top: 0.03rem;
      .acTips {
        color: #ff8301;
      }
      .overClass {
        color: #999;
      }
      .ivu-icon {
        margin: 0 0.05rem;
      }
      .asTime {
        color: #999;
      }
    }

    button {
      border: none;
      outline: none;
      background-color: #fa9284;
      padding: 0 0.08rem;
      height: 0.28rem;
      font-size: 0.14rem;
      color: #fff;
      border-radius: 0.06rem;
    }
    .submit {
      font-size: 0.14rem;
      color: #76d18e;
      background-color: transparent;
    }
  }
  .acItem {
    position: relative;
    float: left;
    width: 2.65rem;
    margin-bottom: 0.3rem;
    margin-right: 0.15rem;
    background-color: #fff;
    border-radius: 0.12rem;
    overflow: hidden;
    padding-bottom: 0.15rem;
  }
  .acItem:nth-child(5n) {
    margin-right: 0;
  }
}
.tip {
  width: 100%;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
}
._icon {
  position: absolute;
  bottom: 0.05rem;
  right: 0.05rem;
  img {
    width: 0.5rem;
  }
}
.shadow {
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/activityList.vue